import React from 'react';
import { motion } from 'framer-motion';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', text = '', fullScreen = false }) => {
  const sizeMap = {
    small: 24,
    medium: 48,
    large: 72
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  const containerVariants = {
    initial: { opacity: 0 },
    animate: { 
      opacity: 1,
      transition: { duration: 0.3 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  };

  const boxVariants = {
    animate: {
      rotateY: [0, 180, 360],
      scale: [1, 1.1, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const glowVariants = {
    animate: {
      opacity: [0.3, 0.8, 0.3],
      scale: [1, 1.2, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const content = (
    <motion.div 
      className={`loading-spinner ${fullScreen ? 'fullscreen' : ''}`}
      variants={containerVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="spinner-content">
        <motion.div 
          className="spinner-glow"
          variants={glowVariants}
          animate="animate"
          style={{ width: spinnerSize * 2, height: spinnerSize * 2 }}
        />
        <motion.div 
          className="spinner-box"
          variants={boxVariants}
          animate="animate"
          style={{ 
            width: spinnerSize, 
            height: spinnerSize,
            fontSize: spinnerSize * 0.6
          }}
        >
          📦
        </motion.div>
      </div>
      {text && (
        <motion.p 
          className="spinner-text"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          {text}
        </motion.p>
      )}
    </motion.div>
  );

  return content;
};

export default LoadingSpinner;

